<template>
    <b-modal ref="farbkarteModal" size="xl" :title="modalTitle" ok-only>
        <spinner v-if="loading"></spinner>
        <div v-else-if="farbkarte">
            <b-row v-if="farbkarte.karte" class="mb-3">
                <b-col>
                    <img :src="articleImageResource(farbkarte.karte, 600)"
                         class="img-fluid"
                         @error="$event.target.style.display='none'"
                         :alt="farbkarte.karte"/>
                </b-col>
            </b-row>
            <div v-if="farbenWithFoto.length > 0" class="farbkarte-grid">
               <b-row>
                  <div v-for="(color, index) in farbenWithFoto"
                       :key="index" class="col-md-5ths col-lg-2dot4 article-link mb-2 card-deck">
                     <pb-card :hoverable="false">
                        <template slot="image">
                           <img :src="imageResource(color.foto, 240)"
                                alt="thumbnail"/>
                        </template>
                        <template slot="content">
                              <span
                                  class="d-block">{{ color.farbnummer }}</span>
                        </template>
                     </pb-card>
                  </div>
               </b-row>
            </div>
            <b-alert v-else variant="info" show>No color images available for this material.</b-alert>
        </div>
        <div v-else-if="error">
            <b-alert variant="warning" show>{{ error }}</b-alert>
        </div>
    </b-modal>
</template>
<script>
import ArticleApi from "@shared/_api/article";
import Spinner from "../ui/Spinner";

export default {
    name: 'farbkarte-modal',
    components: {
        'spinner': Spinner
    },
    data() {
        return {
            loading: false,
            farbkarte: null,
            error: null
        }
    },
    computed: {
        farbenWithFoto() {
            if (this.farbkarte && this.farbkarte.farben) {
                return this.farbkarte.farben.filter(c => c.foto);
            }
            return [];
        },
        modalTitle() {
            if (this.farbkarte) {
                return `Color Card - ${this.farbkarte.qualitaetnummer}`;
            }
            return 'Color Card';
        }
    },
    methods: {
        show(quality) {
            this.farbkarte = null;
            this.error = null;
            this.loading = true;
            this.$refs.farbkarteModal.show();

            ArticleApi.farbkarteByQuality(quality).then(data => {
                this.farbkarte = data;
            }).catch(() => {
                this.error = 'No color card found for this material.';
            }).finally(() => {
                this.loading = false;
            });
        },
        onImageError(event, color) {
            let el = event.target;
            let parent = el.parentElement;
            el.style.display = 'none';
            let fallback = document.createElement('div');
            fallback.className = 'farbkarte-color-number';
            fallback.textContent = color.farbnummer;
            parent.insertBefore(fallback, el);
        }
    }
}
</script>
<style lang="scss" scoped>
.farbkarte-grid {
    .farbkarte-color-item {
        border: 1px solid #eee;
        border-radius: 4px;
        min-height: 80px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .farbkarte-color-img {
        max-height: 80px;
        object-fit: contain;
    }

    .farbkarte-color-number {
        font-size: 18px;
        font-weight: bold;
        padding: 15px 0;
    }
}
</style>